import "./style.css";
import React, { useContext } from 'react';
import { HelmetProvider } from "react-helmet-async";
import { Container, Row, Col, Card } from "react-bootstrap"; 
import { section_b2b } from "../../content_option";
import { LanguageContext } from '../../data/language_context';

// Helper function to generate the correct key for section_b2b lookups
const getLangKey = (selectedLang) => {
  switch (selectedLang) {
    case "Spanish": return "_esp";
    case "Catalan": return "_cat"; // This line is now fixed
    case "English":
    default: return "_eng";
  }
};

export const B2B = () => {
  const { language: selectedLang } = useContext(LanguageContext);
  const langSuffix = getLangKey(selectedLang); // Determine suffix once

  // Helper function to select text by language from section_b2b
  const t = (baseKey) => section_b2b[`${baseKey}${langSuffix}`] || "";

  return (
    <HelmetProvider>
      <Container className="About-header">
        <Row className="sec_sp">
          <Col lg="2">
            <h3 className="color_sec py-4">{t("section_services")}</h3>
          </Col>
          <Col lg="16" className="service-list-container">
            <Row>
              {section_b2b.map((data, i) => {
                const serviceImage = data[`image`];
                const serviceTitle = data[`title${langSuffix}`];
                const serviceDescription = data[`description${langSuffix}`];
                
                return (
                  // 1 column on mobile, 2 on tablets, 2 on desktops
                  <Col xs={12} md={6} lg={6} key={i} className="mb-4">
                    
                    <Card className="service-card h-100">
                      <Card.Img 
                        variant="top" 
                        src={serviceImage} 
                        alt={`${serviceTitle} Icon`}
                        className="service-card__image"
                      />
                      <Card.Body className="d-flex flex-column">
                        <Card.Title as="h5" className="service__title">
                          {serviceTitle}
                        </Card.Title>
                        <Card.Text as="p" className="service_desc">
                          {serviceDescription}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>

      </Container>
    </HelmetProvider>
  );
};